module.exports = __webpack_public_path__ + "static/media/slideshow-image_One.97aa618e.png";